export class TenantInfo {
  id: string;
  name: string;

  constructor() {
    // if no id is set, this is a global endpoint
    this.name = 'No tenant context';
  }
}
export class Tenant {
  id: string;
  name: string;
  domains: string[];
}
